export default __webpack_public_path__ + "static/media/andro-lab.de2a20fc.jpg";